import styled, { keyframes, StyledComponent } from 'styled-components';

const reflect = keyframes`
  0% { transform: scale(0) rotate(45deg); opacity: 0; }
  50% { transform: scale(0) rotate(45deg); opacity: 0.5; }
  71% { transform: scale(4) rotate(45deg); opacity: 1; }
  100% { transform: scale(50) rotate(45deg); opacity: 0; }
`;

export const Reflection = styled.div`
  height: 100%;
  width: 30px;
  position: absolute;
  top: -180px;
  left: 0;
  background: #fff;
  opacity: 0;
  transform: rotate(45deg);
  animation: ${reflect} 4s ease-in-out infinite;
  -webkit-transform: rotate(45deg);
  -webkit-animation: ${reflect} 4s ease-in-out infinite;
  -moz-transform: rotate(45deg);
  -moz-animation: ${reflect} 4s ease-in-out infinite;
  -ms-transform: rotate(45deg);
  -ms-animation: ${reflect} 4s ease-in-out infinite;
  -o-transform: rotate(45deg);
  -o-animation: ${reflect} 4s ease-in-out infinite;
`;

export const reflective = (component: StyledComponent<any, any, any, any>) => styled(component)`
  position: relative;
  left: 50%;
  transform: translate(-50%, 0%);
  -webkit-transform: translate(-50%, 0%);
  -moz-transform: translate(-50%, 0%);
  -ms-transform: translate(-50%, 0%);
  -o-transform: translate(-50%, 0%);
  overflow: hidden;
`;